export const TYPES = ['NWB', 'NA', 'AFK', 'IBA', 'INB']
